import React, { Component } from 'react';
import { withRouter } from 'react-router';

import brand from '../../../public/img/brand.png';
import '../../../public/css/login.css';
import log from 'loglevel';

import { login } from '../../actions/Auth.js';
import { connect } from 'react-redux';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: ''
    };
  }

	handleEmailChange(e) {
	   this.setState({email: e.target.value});
	}
	handlePasswordChange(e) {
	   this.setState({password: e.target.value});
	}

	handleSubmit(e) {
		log.debug(this);
		e.preventDefault();
		this.props.dispatch(login(this.state.email, this.state.password));
	}

  render() {
  	const self = this;

    return (
			<div className="container">
			    <div className="row">
			        <div className="col-sm-6 col-md-4 col-md-offset-4">
			            <div className="account-wall">
			                <img className="brand-logo" src={brand} role="presentation" />

			                <form className="form-signin" onSubmit={this.handleSubmit.bind(self)}>
				                <input type="text" className="form-control" placeholder="Email" required autoFocus onChange={this.handleEmailChange.bind(this)} />
				                <input type="password" className="form-control" placeholder="Password" required onChange={this.handlePasswordChange.bind(this)} />
				                <button className="btn btn-lg btn-primary btn-block" type="submit">
			                    Sign in
				                </button>
			                </form>
			            </div>
			        </div>
			    </div>
			</div>
    );
  }
}

function mapStateToProps(state, props) {
	console.log(state);		
  return {
    cart: state.cart
  };
}

export default connect(mapStateToProps)(withRouter(Login));



// WEBPACK FOOTER //
// ./src/components/auth/Login.js